export default {
  title: 'Pay with {{method}}',
  hint: 'Next, you confirm the payment with your bank or in your app.',
  continue: 'Continue',
  cancel: 'Cancel payment',
  unavailable: 'This payment method is not available right now. Choose another one.',
};
